export const searchInternshipsRoutePathByLocale = {
  en: '/en/internships',
  es: '/es/pasantias',
  pt: '/pt/estagios',
} as const;

export const searchInternshipsRoutePaths = Object.values(
  searchInternshipsRoutePathByLocale,
);

export const searchInternshipsRoutePathsWithoutLang = Array.from(
  new Set(searchInternshipsRoutePaths.map((path) => path.substring(3))),
);
